import {
  EnvironmentProviders,
  ErrorHandler,
  Injector,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ERROR_DISPATCHER, ERROR_PROVIDER, ErrorEventService } from './services/error-event.service';
import { ErrorHandlerProvider } from './services/error-handler-provider.service';
import { ErrorPipelineService } from './services/error-pipeline.service';
import { GlobalErrorHandler } from './services/global-error-handler.service';

export function provideErrorHandling(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    ErrorPipelineService,
    ErrorHandlerProvider,
    ErrorEventService,
    { provide: ERROR_DISPATCHER, useExisting: ErrorEventService },
    { provide: ERROR_PROVIDER, useExisting: ErrorEventService },
    provideAppInitializer(() => {
      const injector = inject(Injector);
      return (injector.get(ErrorHandler) as GlobalErrorHandler).startListening();
    }),
  ]);
}
